import { useQuery } from '@tanstack/react-query';
import { getActiveOutliers } from '@src/api/aiRoadmapOutliers';
import { get, orderBy } from 'lodash';
import { OutlierItemType, OutlierPriority } from '../ContentPanel/types';
import {
  defaultQuerySortBy,
  OUTLIER_METRICS,
  PRIORITY,
} from '../ContentPanel/utils';
import { useAtom } from 'jotai';
import { activeTabSortByAtom } from '../ContentPanel/atoms';

const getMapping = (priorityValue: OutlierPriority) => {
  switch (priorityValue) {
    case PRIORITY.low:
      return 0;
    case PRIORITY.medium:
      return 1;
    case PRIORITY.high:
      return 2;
    default:
      return 0;
  }
};

function useFetchActiveOutliers() {
  const [sortBy, setSortBy] = useAtom(activeTabSortByAtom);
  const onColumnSort = ({ key, order }: any) => {
    setSortBy({ key, order });
  };

  const { isFetching, data, isError, refetch } = useQuery(
    [defaultQuerySortBy],
    async () => {
      const res = await getActiveOutliers(
        {
          query: {
            sortBy: [defaultQuerySortBy],
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
          },
        }
      );
      const { feeds }: { feeds: OutlierItemType } = get(res, ['data'], []);

      return feeds;
    },
    {
      retryOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 30 * 60 * 1000, // 30 mins max we can go without refetching as timezones have 30 mins or 45 mins offsets
    }
  );

  let orderedRows: any = data;

  if (sortBy) {
    orderedRows = OUTLIER_METRICS.includes(sortBy.key)
      ? orderBy(data, (item: any) => item?.metrics?.[sortBy.key], [sortBy.order as any])
      : sortBy.key === 'priority'
      ? orderBy(data, (item) => getMapping(item[sortBy.key]), [sortBy.order as any])
      : orderBy(data, [sortBy.key], [sortBy.order as any]);
  }

  return { isFetching, orderedRows, isError, refetch, sortBy, onColumnSort };
}

export default useFetchActiveOutliers;
